import '../input/select-input';

import { customElement, property, state } from 'lit/decorators.js';

import { cartStore } from '../../_stores/cart-store';
import { FormElement } from './form';

@customElement('checkout-form')
export class CheckoutForm extends FormElement {

    @property({ type: String })
    redirect?: string = null;

    @state()
    _crsf: string = '';

    @state()
    _errors: { [key: string]: string } = {};

    // Lifecycle Hooks

    firstUpdated() {

        // add classes
        this.classList.add('Form', 'Form--checkout');

        // handle slots
        const slot: HTMLElement | null = this.querySelector('[slot="crsf"]');
        if (slot) {
            this._crsf = slot.innerHTML;
            slot.remove();
        }
    }

    // Methods

    protected async _submit() {
        const formData = new FormData(this._form);
        const result = await cartStore.updateCart(formData);
        this._errors = result.errors ?? {};
        if (!result.errors && this.redirect) window.location.href = this.redirect;
    }

}